module.exports = __webpack_public_path__ + "static/media/barcode-alt.d8950259.svg";